import React, { useState } from 'react';
import { saveToScrapbook } from '@/api';
import TextSelectionProvider from '@/components/text-selection/TextSelectionProvider';
import FolderSelectionDialog from '@/components/scrapbook/dialogs/FolderSelectionDialog';

interface ReportPageWrapperProps {
  children: React.ReactNode;
  pageId: string;
  pageTitle: string;
  userId?: string;
  isReportPage: boolean;
  isAuthenticated?: boolean;
  isIpBasedIdentity?: boolean;
  showSaveToScrapbook?: boolean;
}

const ReportPageWrapper: React.FC<ReportPageWrapperProps> = ({ 
  children, 
  pageId, 
  pageTitle, 
  userId, 
  isReportPage,
  isAuthenticated = false,
  isIpBasedIdentity = false,
  showSaveToScrapbook = false,
}) => {
  const [showFolderDialog, setShowFolderDialog] = useState(false);
  const [saveObject, setSaveObject] = useState<any>(null);

  const handleSaveToScrapbook = (extractData: any) => {
    setSaveObject(extractData);
    setShowFolderDialog(true);
  };

  const handleSaveToFolder = async (folderId: number) => {
    await saveToScrapbook(folderId, saveObject, userId);
  };

  const handleCloseFolderDialog = () => {
    setShowFolderDialog(false);
    setSaveObject(null);
  };

  return (
    <>
      {isReportPage ? (
        <TextSelectionProvider 
          pageId={pageId} 
          pageTitle={pageTitle} 
          onSaveToScrapbook={handleSaveToScrapbook}
          isAuthenticated={isAuthenticated || isIpBasedIdentity}
          showSaveToScrapbook={showSaveToScrapbook}
        >
          {children}
        </TextSelectionProvider>
      ) : (
        children
      )}

      {showFolderDialog && saveObject && (
        <FolderSelectionDialog
          isOpen={showFolderDialog}
          onClose={handleCloseFolderDialog}
          onSave={handleSaveToFolder}
          reportTitle={pageTitle}
        />
      )}
    </>
  );
};

export default ReportPageWrapper;
